module.exports = __webpack_public_path__ + "static/media/Client.b21c2cf7.svg";